module.exports = __webpack_public_path__ + "static/media/2.ad6cfa04.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/2.png
// module id = 522
// module chunks = 0